(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    const control = event.target.closest('[data-combined-filter-control]');
    if (!control) return;

    const pairedInput = control.nextElementSibling;
    if (!pairedInput?.matches('[data-combined-filter-value]')) return;
    pairedInput.disabled = !control.checked;
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veloura-product-videos-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('veloura-product-videos')) return;
    const DESKTOP_VISIBLE_COUNT = 5;
    const TRANSITION_DURATION = 460;

    function initVelouraReels(root) {
      if (!root || root.dataset.vlrReady === 'true') {
        return;
      }

      let config;
      try {
        config = JSON.parse(root.querySelector('[data-vlr-config]').textContent);
        if (config.version !== 1 || !Array.isArray(config.videos) || !config.videos.length ||
            config.videos.some(item => !item.url || !item.poster?.src || !item.poster?.small)) {
          root.hidden = true;
          return;
        }
      } catch {
        root.hidden = true;
        return;
      }
      const VIDEO_URLS = config.videos.map(item => item.url);
      const VIDEO_POSTERS = Object.fromEntries(config.videos.map(item => [item.url, item.poster]));
      root.hidden = false;
      root.dataset.vlrReady = 'true';
      let destroyed = false;
      let frame = null;
      let swipeTimer = null;
      const listeners = [];
      const on = (target, type, handler, options) => {
        target.addEventListener(type, handler, options);
        listeners.push(() => target.removeEventListener(type, handler, options));
      };

      const section =
        root.closest('[id^="shopify-section-"]') ||
        root.closest('section') ||
        document;

      const viewport =
        root.querySelector('[data-vlr-viewport]');

      const track =
        root.querySelector('[data-vlr-track]');

      const previousButton =
        root.querySelector('[data-vlr-prev]');

      const nextButton =
        root.querySelector('[data-vlr-next]');

      const modal =
        root.querySelector('[data-vlr-modal]');

      const player =
        modal.querySelector('[data-vlr-player]');

      const playButton =
        modal.querySelector('[data-vlr-play]');

      const muteButton =
        modal.querySelector('[data-vlr-mute]');

      const muteIcon =
        modal.querySelector('[data-vlr-mute-icon]');

      const progress =
        modal.querySelector('[data-vlr-progress]');

      const errorBox =
        modal.querySelector('[data-vlr-error]');

      const modalDots =
        modal.querySelector('[data-vlr-modal-dots]');

      const modalPrevious =
        modal.querySelector('[data-vlr-modal-prev]');

      const modalNext =
        modal.querySelector('[data-vlr-modal-next]');

      const addButton =
        modal.querySelector('[data-vlr-add]');

      const videoCount = VIDEO_URLS.length;

      const cloneCount = Math.min(
        DESKTOP_VISIBLE_COUNT,
        videoCount
      );

      let trackIndex = cloneCount;
      let videoIndex = 0;
      let isMoving = false;
      let moveFallbackTimer = null;
      let touchStartX = 0;
      let touchStartY = 0;
      let didSwipe = false;
      let resizeTimer = null;
      let returnFocus = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const toggleButton = modal.querySelector('[data-vlr-toggle]');
      const pauseLabel = root.dataset.pauseLabel;
      const playLabel = root.dataset.playLabel;

      function createCard(url, originalIndex, isClone = false) {
        const card =
          document.createElement('button');

        const poster =
          document.createElement('img');

        const playIcon =
          document.createElement('span');

        card.type = 'button';
        if (isClone) {
          card.tabIndex = -1;
          card.setAttribute('aria-hidden', 'true');
        }
        card.className = 'vlr-reels__card';

        card.dataset.videoIndex =
          String(originalIndex);

        card.setAttribute(
          'aria-label',
          root.dataset.playNumberLabel.replace('[number]', originalIndex + 1)
        );

        const preview = VIDEO_POSTERS[url];

        if (preview) {
          poster.className = 'vlr-reels__card-poster';
          poster.alt = '';
          poster.setAttribute('aria-hidden', 'true');
          poster.width = preview.width;
          poster.height = preview.height;
          poster.loading = 'lazy';
          poster.decoding = 'async';
          poster.sizes = '(max-width: 749px) 34vw, 240px';
          poster.srcset = `${preview.small} 240w, ${preview.src} 480w`;
          poster.src = preview.src;
          on(poster, 'error', () => poster.remove(), { once: true });
          card.appendChild(poster);
        }

        playIcon.className =
          'vlr-reels__play-icon';

        playIcon.setAttribute(
          'aria-hidden',
          'true'
        );

        card.appendChild(playIcon);

        return card;
      }

      function createInfiniteCards() {
        const fragment =
          document.createDocumentFragment();

        for (
          let index = videoCount - cloneCount;
          index < videoCount;
          index += 1
        ) {
          fragment.appendChild(
            createCard(
              VIDEO_URLS[index],
              index,
              true
            )
          );
        }

        VIDEO_URLS.forEach((url, index) => {
          fragment.appendChild(
            createCard(url, index)
          );
        });

        for (
          let index = 0;
          index < cloneCount;
          index += 1
        ) {
          fragment.appendChild(
            createCard(
              VIDEO_URLS[index],
              index,
              true
            )
          );
        }

        track.appendChild(fragment);
      }

      function getStepWidth() {
        const firstCard =
          track.querySelector(
            '.vlr-reels__card'
          );

        if (!firstCard) {
          return 0;
        }

        const trackStyles =
          window.getComputedStyle(track);

        const gap =
          parseFloat(
            trackStyles.columnGap ||
            trackStyles.gap
          ) || 0;

        return (
          firstCard.getBoundingClientRect().width +
          gap
        );
      }

      function getEdgeOffset() {
        const rootStyles =
          window.getComputedStyle(root);

        return (
          parseFloat(
            rootStyles.getPropertyValue(
              '--vlr-edge-offset'
            )
          ) || 0
        );
      }

      function setTrackPosition(animated) {
        const step = getStepWidth();
        const edgeOffset = getEdgeOffset();

        track.style.transition = animated && !reducedMotion.matches
          ? `transform ${TRANSITION_DURATION}ms cubic-bezier(0.25, 0.8, 0.25, 1)`
          : 'none';

        track.style.transform =
          `translate3d(${edgeOffset - trackIndex * step}px, 0, 0)`;

        if (!animated) {
          track.getBoundingClientRect();
        }
      }

      function normaliseInfinitePosition() {
        if (
          trackIndex >=
          videoCount + cloneCount
        ) {
          trackIndex -= videoCount;
          setTrackPosition(false);
        }

        if (trackIndex < cloneCount) {
          trackIndex += videoCount;
          setTrackPosition(false);
        }
      }

      function finishMovement() {
        window.clearTimeout(
          moveFallbackTimer
        );

        normaliseInfinitePosition();
        isMoving = false;
      }

      function moveOne(direction) {
        if (isMoving || destroyed) {
          return;
        }

        isMoving = true;
        trackIndex += direction;

        setTrackPosition(true);

        moveFallbackTimer =
          window.setTimeout(
            finishMovement,
            TRANSITION_DURATION + 100
          );
      }

      function createModalDots() {
        const fragment =
          document.createDocumentFragment();

        VIDEO_URLS.forEach((url, index) => {
          const dot =
            document.createElement('button');

          dot.type = 'button';

          dot.className =
            'vlr-reels-modal__dot';

          dot.dataset.modalIndex =
            String(index);

          dot.setAttribute(
            'aria-label',
            root.dataset.playNumberLabel.replace('[number]', index + 1)
          );

          fragment.appendChild(dot);
        });

        modalDots.appendChild(fragment);
      }

      function updateModalDots() {
        modalDots
          .querySelectorAll(
            '.vlr-reels-modal__dot'
          )
          .forEach((dot, index) => {
            dot.setAttribute('aria-current', index === videoIndex ? 'true' : 'false');
            dot.classList.toggle(
              'is-active',
              index === videoIndex
            );
          });
      }

      function updatePlayButton() {
        toggleButton.setAttribute('aria-label', player.paused ? playLabel : pauseLabel);
        toggleButton.querySelector('[data-vlr-toggle-icon]').textContent = player.paused ? '▶' : 'Ⅱ';
        playButton.classList.toggle(
          'is-visible',
          player.paused
        );
      }

      function updateMuteButton() {
        muteIcon.textContent =
          player.muted ? '🔇' : '🔊';

        muteButton.setAttribute(
          'aria-label',
          player.muted
            ? root.dataset.unmuteLabel
            : root.dataset.muteLabel
        );
      }

      function releasePlayer() {
        player.pause();
        player.removeAttribute('src');
        player.removeAttribute('poster');
        player.load();
      }

      function loadModalVideo(index) {
        if (destroyed || !modal.open || !Number.isInteger(index)) return;
        videoIndex =
          (
            index +
            videoCount
          ) %
          videoCount;

        player.pause();
        player.removeAttribute('src');
        player.load();

        progress.style.width = '0%';

        errorBox.classList.remove(
          'is-visible'
        );

        const preview = VIDEO_POSTERS[VIDEO_URLS[videoIndex]];
        if (preview) {
          player.poster = preview.src;
        } else {
          player.removeAttribute('poster');
        }
        player.muted = true;
        player.src = VIDEO_URLS[videoIndex];
        player.load();

        updateMuteButton();
        updateModalDots();

        player.play().catch(() => {
          updatePlayButton();
        });
      }

      function openModal(index) {
        returnFocus = track.querySelector('[data-video-index="' + index + '"]:not([aria-hidden])') || document.activeElement;
        modal.classList.add('is-open');
        modal.showModal();
        modal.querySelector('.vlr-reels-modal__close').focus({preventScroll: true});

        modal.setAttribute(
          'aria-hidden',
          'false'
        );

        document.body.classList.add(
          'vlr-reels-lock'
        );

        loadModalVideo(index);
      }

      function closeModal(restoreFocus = true) {
        if (
          !modal.classList.contains(
            'is-open'
          )
        ) {
          return;
        }

        releasePlayer();

        modal.classList.remove('is-open');
        modal.close();
        if (restoreFocus && returnFocus?.isConnected) returnFocus.focus({preventScroll: true});

        modal.setAttribute(
          'aria-hidden',
          'true'
        );

        if (!document.querySelector('.vlr-reels-modal[open]')) document.body.classList.remove('vlr-reels-lock');

        progress.style.width = '0%';
      }

      function togglePlay() {
        if (!modal.open || destroyed || !player.getAttribute('src')) return;
        if (player.paused) {
          player.play().catch(() => {});
        } else {
          player.pause();
        }
      }

      function findMainAddButton() {
        const buttons = Array.from(
          section.querySelectorAll(
            'form[action*="/cart/add"] button[type="submit"]'
          )
        );

        return (
          buttons.find((button) => {
            const text =
              button.textContent
                .trim()
                .toLowerCase();

            return (
              text.includes('add to cart') &&
              button.offsetParent !== null
            );
          }) ||
          buttons.find((button) =>
            button.textContent
              .trim()
              .toLowerCase()
              .includes('add to cart')
          ) ||
          buttons[0]
        );
      }

      on(toggleButton, 'click', togglePlay);
      on(modal, 'cancel', event => {
        event.preventDefault();
        closeModal();
      });
      on(track, 'focusin', event => {
        const card = event.target.closest('[data-video-index]');
        if (!card || card.tabIndex < 0) return;
        window.clearTimeout(moveFallbackTimer);
        isMoving = false;
        trackIndex = cloneCount + Number(card.dataset.videoIndex);
        setTrackPosition(false);
        viewport.scrollLeft = 0;
      });

      createInfiniteCards();
      createModalDots();

      frame = window.requestAnimationFrame(() => {
        frame = window.requestAnimationFrame(() => {
          if (destroyed) return;
          setTrackPosition(false);
        });
      });

      on(track,
        'transitionend',
        (event) => {
          if (
            event.propertyName !== 'transform'
          ) {
            return;
          }

          finishMovement();
        }
      );

      on(track,
        'click',
        (event) => {
          if (didSwipe) {
            return;
          }

          const card =
            event.target.closest(
              '[data-video-index]'
            );

          if (!card) {
            return;
          }

          openModal(
            Number(card.dataset.videoIndex)
          );
        }
      );

      on(previousButton,
        'click',
        () => {
          moveOne(-1);
        }
      );

      on(nextButton,
        'click',
        () => {
          moveOne(1);
        }
      );

      on(viewport,
        'touchstart',
        (event) => {
          const touch =
            event.changedTouches[0];

          touchStartX = touch.clientX;
          touchStartY = touch.clientY;

          didSwipe = false;
        },
        { passive: true }
      );

      on(viewport,
        'touchend',
        (event) => {
          const touch =
            event.changedTouches[0];

          const deltaX =
            touch.clientX - touchStartX;

          const deltaY =
            touch.clientY - touchStartY;

          if (
            Math.abs(deltaX) < 35 ||
            Math.abs(deltaX) <
              Math.abs(deltaY)
          ) {
            return;
          }

          didSwipe = true;

          moveOne(
            deltaX < 0 ? 1 : -1
          );

          swipeTimer = window.setTimeout(() => {
            didSwipe = false;
          }, 250);
        },
        { passive: true }
      );

      on(modalDots,
        'click',
        (event) => {
          const dot =
            event.target.closest(
              '[data-modal-index]'
            );

          if (!dot) {
            return;
          }

          loadModalVideo(
            Number(dot.dataset.modalIndex)
          );
        }
      );

      modal
        .querySelectorAll('[data-vlr-close]')
        .forEach((button) => {
          on(button,
            'click',
            () => closeModal()
          );
        });

      on(modalPrevious,
        'click',
        () => {
          loadModalVideo(videoIndex - 1);
        }
      );

      on(modalNext,
        'click',
        () => {
          loadModalVideo(videoIndex + 1);
        }
      );

      on(player,
        'click',
        togglePlay
      );

      on(playButton,
        'click',
        togglePlay
      );

      on(player,
        'play',
        updatePlayButton
      );

      on(player,
        'pause',
        updatePlayButton
      );

      on(player,
        'timeupdate',
        () => {
          if (
            !Number.isFinite(
              player.duration
            ) ||
            player.duration <= 0
          ) {
            progress.style.width = '0%';
            return;
          }

          const percentage =
            (
              player.currentTime /
              player.duration
            ) * 100;

          progress.style.width =
            `${Math.min(
              100,
              Math.max(0, percentage)
            )}%`;
        }
      );

      on(player,
        'ended',
        () => {
          if (!document.hidden) loadModalVideo(videoIndex + 1);
        }
      );

      on(player,
        'error',
        () => {
          if (!modal.open || !player.getAttribute('src')) return;
          errorBox.classList.add(
            'is-visible'
          );

          playButton.classList.remove(
            'is-visible'
          );
        }
      );

      on(muteButton,
        'click',
        () => {
          player.muted = !player.muted;
          updateMuteButton();

        }
      );

      if (addButton) {
        on(addButton,
          'click',
          () => {
            const mainAddButton =
              findMainAddButton();

            if (
              mainAddButton &&
              !mainAddButton.disabled
            ) {
              closeModal();
              mainAddButton.click();
            }
          }
        );
      }

      on(modal,
        'touchstart',
        (event) => {
          const touch =
            event.changedTouches[0];

          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        },
        { passive: true }
      );

      on(modal,
        'touchend',
        (event) => {
          const touch =
            event.changedTouches[0];

          const deltaX =
            touch.clientX - touchStartX;

          const deltaY =
            touch.clientY - touchStartY;

          if (
            Math.abs(deltaX) < 55 ||
            Math.abs(deltaX) <
              Math.abs(deltaY)
          ) {
            return;
          }

          loadModalVideo(
            deltaX > 0
              ? videoIndex - 1
              : videoIndex + 1
          );
        },
        { passive: true }
      );

      on(document,
        'keydown',
        (event) => {
          if (
            !modal.classList.contains(
              'is-open'
            )
          ) {
            return;
          }

          if (event.key === 'Tab') {
            const controls = Array.from(modal.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'))
              .filter(control => control.tabIndex >= 0 && control.getClientRects().length > 0);
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) {
              event.preventDefault();
              last?.focus();
            } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === modal)) {
              event.preventDefault();
              first?.focus();
            }
          }
          if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
            return;
          }
          if (event.target.closest('input, select, textarea')) return;
          if (event.key === ' ' && !event.target.closest('button, a')) {
            event.preventDefault();
            togglePlay();
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            loadModalVideo(
              videoIndex - 1
            );
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            loadModalVideo(
              videoIndex + 1
            );
          }
        }
      );

      on(window,
        'resize',
        () => {
          window.clearTimeout(
            resizeTimer
          );

          resizeTimer =
            window.setTimeout(() => {
              setTrackPosition(false);
            }, 120);
        }
      );

      on(document, 'visibilitychange', () => {
        if (document.hidden) player.pause();
      });
      on(viewport, 'touchcancel', () => {
        didSwipe = false;
      });
      const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(() => {
        if (!destroyed) setTrackPosition(false);
      }) : null;
      resizeObserver?.observe(viewport);
      on(document, 'shopify:section:unload', event => {
        if (event.target.contains(root)) root.destroy();
      });
      return () => {
        destroyed = true;
        listeners.forEach(remove => remove());
        resizeObserver?.disconnect();
        window.clearTimeout(moveFallbackTimer);
        window.clearTimeout(resizeTimer);
        window.clearTimeout(swipeTimer);
        window.cancelAnimationFrame(frame);
        closeModal(false);
        releasePlayer();
        track.replaceChildren();
        modalDots.replaceChildren();
        delete root.dataset.vlrReady;
      };
    }

  class VelouraProductVideos extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this.cleanup) this.cleanup = initVelouraReels(this);
      });
    }
    disconnectedCallback() { this.destroy(); }
    destroy() {
      this.cleanup?.();
      this.cleanup = null;
    }
  }
  customElements.define('veloura-product-videos', VelouraProductVideos);
})();
  } catch(e) { console.error(e); }
})();

})();
